import { EventEmitter, Injectable, Output } from '@angular/core';
import { DataProvider } from '../providers/data';
import { LocalStorageService } from './localStorage.service';
import { Firebase } from '@ionic-native/firebase';
import { API } from './api';

@Injectable()
export class ChatService {

  @Output() broadcast: EventEmitter<any> = new EventEmitter();

  constructor(private dataProvider: DataProvider,
              private localStorage: LocalStorageService,
              private firebase: Firebase,
              private api: API) {
  }

  currentUserSubscription: any;
  chats: any = [];
  public unreadMessages = 0;
  userTeam: string;
  userUID: string;
  initialCheck = true;

  /**
   * Send broadcast change to subscribed pages.
   */
  emitChanges(data: any) {
    console.log('emitChanges');
    
    this.broadcast.emit(data);
  }

  /**
   * Subscribe page to changes.
   */
  listenChanges() {
    console.log('listenChanges');
    
    return this.broadcast;
  }

  /**
   * Singleton of notifications tracking.
   */
  trackNotifications() {
    console.log('trackNotifications');
    
    this.localStorage.getTeam().then(team => {
      console.log('TEAM', team);
      
      this.userTeam = team;
      if (this.userTeam) {
        this.localStorage.getUID().then(uid => {
          this.userUID = uid;
          
          if (this.userUID) {
            this.currentUserSubscription = this.dataProvider
              .getUser(this.userTeam, this.userUID).snapshotChanges().subscribe((conversationId) => {
                console.log('conversationId',conversationId);
                
                this.initialCheck = true;
                const remoteIndividual = conversationId.payload.child('conversations').toJSON();
                const remoteGroup = conversationId.payload.child('conversationsGroups').toJSON();
                const promises = [];
                if (remoteIndividual && remoteIndividual.toString().trim() !== '') {
                  this.processRemoteChats('conversations', remoteIndividual).forEach(newPromise => {
                    promises.push(newPromise);
                  });
                }
                if (remoteGroup && remoteGroup.toString().trim() !== '') {
                  this.processRemoteChats('conversationsGroups', remoteGroup).forEach(newPromise => {
                    promises.push(newPromise);
                  });
                }
                Promise.all(promises).then(conversations => {

                  for (const conversation of conversations) {
                    this.processNewMessages(conversation);
                  }
                  this.initialCheck = false;
                  this.reorderToFreshlyUpdated();

                });
              });
          }

        });
      } else {
        this.logoutSubscriptions();
      }
    });
  }

  /**
   * logic to determine if is required to monitor a conversation .
   */
  processRemoteChats(type: string, remoteConversations) {
    console.log('processRemoteChats');
    
    const partialPromises = [];
    if (remoteConversations != '') {
      for (const remoteID in remoteConversations) {
        const alreadyExistLocal = this.chats.find(localConv => {
          return localConv.id == remoteID;
        });
        // si la conversacion no existe en local
        if (!alreadyExistLocal) {
          partialPromises.push(new Promise((resolve, reject) => {
            this.generateSubscription(remoteID, type, remoteConversations[remoteID], resolve);
          }));
          // si la conversacion ya existe en local y recibo un cambio a activa
        }
      }

      return partialPromises;
    }
  }

  /**
   * remove locally subscrition and data of a conversation.
   */
  deleteLocalChat(localID, unsubscribe) {
    console.log('deleteLocalChat');
    
    this.chats = this.chats.filter(currentSubscription => {
      if (currentSubscription.id == localID) {
        if (unsubscribe) currentSubscription.subscription.unsubscribe();
        return false;
      } else return true;
    });
  }

  /**
   * Obtiene timestamp de la conversación individual.
   */
  generateSubscription(id, type, activeChat, resolve?) {
    console.log('id',id)
    console.log('type',type)
    console.log('activeChat',activeChat)
    console.log('resolve',resolve)
    this.chats.push({
      id,
      type,
      subscription: this.dataProvider.getConversation(this.userTeam, type, id)
        .snapshotChanges()
        .subscribe((conversation) => {
          console.log('conversation',conversation);
          
          if (this.initialCheck) {
            resolve(conversation);
          } else {
            this.processNewMessages(conversation);
          }
        },error => {
          console.log('error',error);
          
        }),
    });
  }

  /**
   * Obtiene timestamp de la conversación individual.
   */
  obtainArchivedConversation(id, type, resolve?) {
    console.log('idObtainArchived',id)
    console.log('typeObtainArchived',type)
    console.log('resolveObtainArchived',resolve)
    this.chats.push({
      id,
      archived: true,
    });
    this.dataProvider.getConversation(this.userTeam, type, id)
      .query
      .once('value', (conversation) => {
        console.log('conversationObtainArchived',conversation);
        
        conversation['archived'] = true;
        if (this.initialCheck) {
          resolve(conversation);
        } else {
          this.processNewMessages(conversation);
        }
      }, error => {
        console.log('errorObtainArchived',error);
        
      });
  }

  /**
   * reorder new conversation to top.
   */
  reorderToTop(conversationID) {
    console.log('reorderToTop');
    
    this.chats.sort((x, y) => {
      return x.id == conversationID ? -1 : y.id == conversationID ? 1 : 0;
    });

  }

  /**
   * reorder conversations to freshly updated.
   */
  reorderToFreshlyUpdated() {
    console.log('reorderToFreshlyUpdated');
    
    this.chats.sort((x, y) => {
      return ((y.data.conversation.lastDate) ? y.data.conversation.lastDate[0] : 0) -
        ((x.data.conversation.lastDate) ? x.data.conversation.lastDate[0] : 0);
    });

  }

  /**
   * process new info and notification badge number.
   */
  processNewMessages(conversation) {
    console.log('processNewMessages');
    

    if (conversation.payload) {

      const localIndex = this.chats.findIndex(localConv => {
        return localConv.id == conversation.key;
      });

      // new remote info
      const remoteTotalConvMessages = conversation.payload.child('messages').numChildren();
      const remoteTotalReadedConvMessages = conversation.payload.child('messagesRead').child(this.userUID).child('0').val();
      const remoteUnreadMessages = (remoteTotalConvMessages > remoteTotalReadedConvMessages)
        ? remoteTotalConvMessages - remoteTotalReadedConvMessages : 0;

      let partialUnreadMessages;

      // compare with local
      if (this.chats[localIndex] && this.chats[localIndex].data) {

        partialUnreadMessages = remoteUnreadMessages - this.chats[localIndex].data.unreadedMessages;
        this.chats[localIndex].data.unreadedMessages = remoteUnreadMessages;
        const auxParticipant = this.chats[localIndex].data.conversation.participants;
        this.chats[localIndex].data.conversation = conversation.payload.val();
        this.chats[localIndex].data.conversation.participants = auxParticipant;
      } else {
        this.chats[localIndex].data = {
          conversation: conversation.payload.val(),
          unreadedMessages: remoteUnreadMessages,
        };

        partialUnreadMessages = remoteUnreadMessages;
      }

      // conversacion archivada?
      this.checkIfArchived(this.chats[localIndex], conversation);

      // actualizo lo necesario de la UI
      if (!this.initialCheck) {
        this.updateChatUI(partialUnreadMessages, conversation);
      } else if (conversation.payload.child('type').val() == 'individual') {
        this.getParticipantInfo(this.chats[localIndex]);
      }

      // actualizo bocadillos
      this.unreadMessages += partialUnreadMessages;
      this.firebase.setBadgeNumber(this.unreadMessages);

    }

  }

  /**
   * check if conversation is archived.
   */
  checkIfArchived(localConversation, remoteConversation) {
    console.log('checkIfArchived');
    
    if (remoteConversation.payload.hasChild('messages')) {
      const isArchivedByMe = (remoteConversation.payload.hasChild('messagesDeleted')
        && remoteConversation.payload.child('messagesDeleted').child(this.userUID).child('dayDeleted').val() != 0)
        ? remoteConversation.payload.child('messagesDeleted').child(this.userUID).child('dayDeleted').val()
        : 0;
      const lastMessageKey = Object.keys(remoteConversation.payload.child('messages').val())[remoteConversation.payload.child('messages').numChildren() - 1];
      localConversation.archived = remoteConversation.payload.hasChild('messages')
        && (isArchivedByMe != 0)
        && (remoteConversation.payload.child('messages').child(lastMessageKey).child('date').val() < isArchivedByMe);
    } else localConversation.archived = false;
  }

  /**
   * get initial info for participants of conversations.
   */
  getParticipantInfo(localConversation) {
    console.log('getParticipantInfo');
    
    delete localConversation.data.conversation.participants[this.userUID];
    this.api.obtenerDetailUserFirebase(Object.keys(localConversation.data.conversation.participants)[0]).then(response => {
      localConversation.data.conversation.participants[Object.keys(localConversation.data.conversation.participants)[0]] = {
        image_resize: response.image,
        name: response.name,
        firebase_uid: Object.keys(localConversation.data.conversation.participants)[0],
      };
      // TODO: revisar porque en ios no funciona bien algunas veces
      /*if (this.utils.getIsApp()) {
        this.imageLoader.preload(response.image).then(cached => {
          localConversation.data.conversation.participants[Object.keys(localConversation.data.conversation.participants)[0]] = {
            image_resize: cached,
            remote_image_resize: response.image,
            name: response.name,
            firebase_uid: Object.keys(localConversation.data.conversation.participants)[0],
          };
        });
      } else {
        localConversation.data.conversation.participants[Object.keys(localConversation.data.conversation.participants)[0]] = {
          image_resize: response.image,
          name: response.name,
          firebase_uid: Object.keys(localConversation.data.conversation.participants)[0],
        };
      }*/
    }).catch(err => {
      console.error(err);
    });
  }

  /**
   * update chatUserUI.
   */
  updateChatUI(partialUnreadMessages, conversation) {
    console.log('updateChatUI');
    
    if (conversation.payload.val().messages) {
      const newMesssageKey = Object.keys(conversation.payload.val().messages)[Object.keys(conversation.payload.val().messages).length - 1];
      this.emitChanges({
        idChanged: conversation.key,
        newMessage: (partialUnreadMessages > 0) ? conversation.payload.val().messages[newMesssageKey] : null,
      });
      this.reorderToTop(conversation.key);
    }

  }

  /**
   * update user connection status.
   */
  updateUserConnectionStatus(isOnline: boolean) {
    console.log('updateUserConnectionStatus');
    
    console.log('Entra en chatservice al arrancar')

    if (!isOnline) {
      console.log('esta offline');
      
      this.localStorage.setDateBackgroundMode(new Date().getTime());
    }else{
      console.log('está online');
      
    }

    return this.dataProvider.getUser(this.userTeam, this.userUID)
      .update({
        online: isOnline,
        lastConnection: this.dataProvider.getTimeStamp(),
      });
  }

  /**
   * get current server time.
   */
  getCurrentServerTime() {
    console.log('getCurrentServerTime');
    
    return this.updateUserConnectionStatus(true).then(res => {
      return this.dataProvider.getUser(this.userTeam, this.userUID)
        .query
        .once('value');
    });
  }

  /**
   * process logout a user subscriptions.
   */
  logoutSubscriptions() {
    console.log('logoutSubscriptions');
    
    if (this.chats.length > 0) {
      for (const subscription of this.chats) {
        if (subscription.subscription) subscription.subscription.unsubscribe();
      }
    }
    if (this.currentUserSubscription) this.currentUserSubscription.unsubscribe();
    this.chats = [];

  }
}



// WEBPACK FOOTER //
// ./src/services/chat.service.ts